import { render, staticRenderFns } from "./SolicitudMuestras.vue?vue&type=template&id=10125c80&scoped=true"
import script from "./SolicitudMuestras.vue?vue&type=script&lang=js"
export * from "./SolicitudMuestras.vue?vue&type=script&lang=js"
import style0 from "./SolicitudMuestras.vue?vue&type=style&index=0&id=10125c80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10125c80",
  null
  
)

export default component.exports